import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, Button, Box, Typography } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const ContractSigningBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAgreementStatus = async () => {
      try {
        // Check if there's an agreement document
        const docsResponse = await api.get('/api/documents?category=agreement');
        const hasAgreement = docsResponse.data && docsResponse.data.length > 0;
        
        if (!hasAgreement) {
          setShowBanner(false);
          setLoading(false);
          return;
        }

        // Check if counsellor has signed
        const counsellorResponse = await api.get('/api/counsellors/me');
        const contractSigned = counsellorResponse.data?.contractSigned || false;
        
        setShowBanner(!contractSigned);
      } catch (error) {
        console.error('Error checking agreement status:', error);
        setShowBanner(false);
      } finally {
        setLoading(false);
      }
    };

    checkAgreementStatus();
  }, []);

  if (loading || !showBanner) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Alert 
        severity="warning" 
        icon={<WarningIcon sx={{ fontSize: 32 }} />}
        sx={{
          backgroundColor: '#fff3e0',
          border: '2px solid #ff9800',
          borderRadius: '8px',
          padding: '16px 24px',
          boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)',
          '& .MuiAlert-icon': {
            color: '#ff9800',
            alignItems: 'center'
          },
          '& .MuiAlert-message': {
            width: '100%',
            color: '#000'
          }
        }}
        action={
          <Button 
            variant="contained"
            size="large"
            onClick={() => navigate('/counsellor/sign-agreement')}
            sx={{
              backgroundColor: '#ff9800',
              color: '#fff',
              fontWeight: 600,
              fontSize: '16px',
              padding: '10px 32px',
              textTransform: 'none',
              boxShadow: '0 2px 8px rgba(255, 152, 0, 0.3)',
              '&:hover': {
                backgroundColor: '#f57c00',
                boxShadow: '0 4px 12px rgba(255, 152, 0, 0.4)'
              }
            }}
          >
            Sign Now
          </Button>
        }
      >
        <AlertTitle sx={{ 
          fontWeight: 700, 
          fontSize: '18px',
          color: '#e65100',
          mb: 1
        }}>
          ⚠️ Action Required: Sign Your Counsellor Agreement
        </AlertTitle>
        <Typography sx={{ fontSize: '15px', color: '#424242' }}>
          You must read and sign the counsellor agreement before you can be assigned clients. 
          This is a one-time requirement and only takes a few minutes.
        </Typography>
      </Alert>
    </Box>
  );
};

export default ContractSigningBanner;
